let kidsLpVideo = function(){
    var selectors = {
        autoplayVideo: document.querySelectorAll("[data-autoplay-video]")
    };

    let autoplayVideo = function(){
        if(selectors.autoplayVideo){

            selectors.autoplayVideo.forEach(video => {
                var videoObserver = new IntersectionObserver(function(videos) {
                    if(videos[0].isIntersecting === true){
                        video.play();
                    } else{
                        video.pause();
                    }
                  }, { threshold: [1] });
                  videoObserver.observe(video);
            })
        }
    }
    
    autoplayVideo();
}();